class XstoVideoGallery extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;

    this.dataset.ready = 'true';
    this.triggers = Array.from(this.querySelectorAll('[data-video-trigger]'));
    this.panels = Array.from(this.querySelectorAll('[data-video-panel]'));

    this.triggers.forEach((trigger, index) => {
      trigger.addEventListener('click', () => this.activate(trigger));
      trigger.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;

        event.preventDefault();
        const direction = ['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1;
        const nextIndex = (index + direction + this.triggers.length) % this.triggers.length;
        this.activate(this.triggers[nextIndex]);
        this.triggers[nextIndex].focus();
      });
    });

    this.querySelectorAll('[data-youtube-load]').forEach((button) => {
      button.addEventListener('click', () => this.loadYoutube(button), { once: true });
    });
  }

  loadYoutube(button) {
    const facade = button.closest('[data-youtube-facade]');
    if (!facade || facade.dataset.loaded === 'true') return;
    const videoId = facade.dataset.youtubeId;
    const videoTitle = facade.dataset.youtubeTitle || '';
    if (!videoId) return;
    facade.dataset.loaded = 'true';

    const iframe = document.createElement('iframe');
    iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}?rel=0&playsinline=1&autoplay=1&enablejsapi=1`;
    iframe.title = videoTitle;
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    button.replaceWith(iframe);
  }

  activate(trigger) {
    const targetId = trigger.getAttribute('aria-controls');

    this.triggers.forEach((item) => {
      const isActive = item === trigger;
      item.setAttribute('aria-selected', String(isActive));
      item.tabIndex = isActive ? 0 : -1;
    });

    this.panels.forEach((panel) => {
      const isActive = panel.id === targetId;
      panel.hidden = !isActive;

      if (!isActive) this.pause(panel);
    });
  }

  pause(panel) {
    panel.querySelectorAll('video').forEach((video) => video.pause());
    panel.querySelectorAll('iframe').forEach((iframe) => {
      iframe.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), '*');
      iframe.contentWindow?.postMessage(JSON.stringify({ method: 'pause' }), '*');
    });
  }
}

if (!customElements.get('xsto-video-gallery')) {
  customElements.define('xsto-video-gallery', XstoVideoGallery);
}
